import React, { useMemo, useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import arrowright from "../../../assets/arrowright.svg";
import Vectorsorting from "../../../assets/Vectorsorting.svg";
import { useNavigate } from "react-router";
import ShimmerLoader from "../../../loading";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import CustomPagination from "../../../components/CustomWidgets/CustomPagination";

const AllProductsTable = ({ tabledata, pagination, startDate, endDate }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [flag, setflag] = useState(false);

  const is_lahloob = useSelector(
    (state) => state.login?.user?.result?.is_lahloob,
  );

  const lang = i18n.language;

  console.log("TABLE  DATA _------>", tabledata);

  const data = useMemo(() => {
    if (Array.isArray(tabledata)) {
      return tabledata;
    } else if (tabledata && typeof tabledata === "object") {
      return [];
    }
    return [];
  }, [tabledata]);

  useEffect(() => {
    if (data.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 1000);

      return () => clearTimeout(timer);

    
    }
  }, [data, flag]);

   

 const columns = useMemo(
  () => [
    {
      Header: t("Barcode"),
      accessor: "barcode",
      width: "12%",
    },
    {
      Header: t("Product Name"),
      accessor: "product_name",
      width: "30%",
     Cell: ({ row }) => (
    <div
      className="text-start overflow-hidden text-ellipsis whitespace-nowrap"
      title={
        row.original.product_name2 && row.original.product_name2 !== ""
          ? row.original.product_name2
          : row.original.product_name
      }
    >
      {row.original.product_name2 && row.original.product_name2 !== ""
        ? row.original.product_name2
        : row.original.product_name}
    </div>
  ),
    },
    {
      Header: t("Product Groups"),
      accessor: "product_group",
      width: "20%",
      Cell: ({ row }) => (
        <div className="text-start">
          {row.original.product_group}
        </div>
      ),
    },
    {
      Header: t("Inventory in Days"),
      accessor: "inv_in_days",
      width: "12.5%",
    },
    {
      Header: t("Current Stock Value"),
      accessor: "current_stock_value",
      width: "16%",
    },
  ],
  [t]
);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination,
  );

  const [pageIndex, setpageIndex] = useState(1);

  


  useEffect(() => {
    const pageDetails = {
      limit: pageSize || 10,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };

    if (pageSize) pagination(pageDetails);
  }, [pageSize, pageIndex]);

  return (
    <>
      <div
        className="w-full mx-auto float-left h-[100%]"
        style={{ maxWidth: "100%" }}
      >
        {tabledata?.length == 0 && flag == false ? (
          <div className="h-screen w-[90%] mt-2 ">
            <ShimmerLoader />
          </div>
        ) : (
          <>
            {/* Header Table (Fixed) */}
            <div className="w-full overflow-x-auto">
              <table
                className="font-normal w-full min-w-[1100px] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr
                      {...headerGroup.getHeaderGroupProps()}
                      className="bg-[#78CFEC66] text-sm font-semibold text-start"
                    >
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps(),
                          )}
                          className="py-2 px-2 md:py-3 text-[11px] md:text-sm whitespace-nowrap"
                          style={{
                            width: column.width,
                            textAlign: "left",
                          }}
                        >
                          <div className="flex flex-row items-center ms-1 md:ms-2 text-[11px] md:text-sm leading-tight whitespace-nowrap">
                            {column.render("Header")}

                            {column.canSort && (
                              <span className="ms-1">
                                {column.isSorted ? (
                                  column.isSortedDesc ? (
                                    <img
                                      src={Vectorsorting}
                                      style={{
                                        minHeight: 10,
                                        minWidth: 10,
                                      }}
                                      alt="vector"
                                    />
                                  ) : (
                                    <img
                                      className="rotate-180"
                                      src={Vectorsorting}
                                      alt="vector"
                                    />
                                  )
                                ) : (
                                  <img
                                    src={Vectorsorting}
                                    alt="sortable"
                                    style={{
                                      minHeight: 10,
                                      minWidth: 10,
                                      opacity: 0.3,
                                    }}
                                  />
                                )}
                              </span>
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
              </table>
            </div>

            {/* Table Body */}
            <div
              className="scrollbar-none bg-white overflow-x-auto"
              style={{ overflowY: "auto", maxHeight: "650px" }}
            >
              <table
                {...getTableProps()}
                className="font-normal w-full min-w-[1100px] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <tbody
                  {...getTableBodyProps()}
                  className="bg-[#F7F9FD] text-start overflow-hidden"
                >
                  {page.map((row) => {
                    prepareRow(row);

                    return (
                      <tr
                        {...row.getRowProps()}
                        className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300"
                      >
                        {row.cells.map((cell, index) => (
                          <td
                            key={index}
                            {...cell.getCellProps()}
                            className="p-2 text-[#272728] text-[11px] md:text-sm font-normal whitespace-nowrap"
                            style={{ width: cell.column.width }}
                          >
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })}

                  {page.length === 0 && (
                    <tr>
                      <td colSpan={100}>
                        <Empty
                          className="mt-10"
                          description={t("No data available")}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="">
              <CustomPagination
                data={data?.length}
                pageIndex={pageIndex}
                pageCount={page?.length}
                canPreviousPage={pageIndex != 1 ? true : false}
                canNextPage={data?.length == pageSize ? true : false}
                gotoPage={(page) => {
                  nextPage(page);
                }}
                previousPage={() => {
                  setpageIndex(pageIndex - 1);
                }}
                nextPage={() => {
                  setpageIndex(pageIndex + 1);
                }}
                pageSize={pageSize}
                setPageSize={(pageSize) => {
                  setPageSize(pageSize);
                }}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AllProductsTable;